import { defineMessage, useIntl } from 'react-intl';

import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';

const title = defineMessage({
  id: 'slot.service.label',
  defaultMessage: 'Service & Hilfe',
});

export const useServiceLink = () => {
  const { formatMessage } = useIntl();
  const { locale, defaultLocale } = useI18n();
  const { headerSlots } = useConfig();

  return {
    href: headerSlots.serviceLink[locale] ?? headerSlots.serviceLink[defaultLocale],
    label: formatMessage(title),
  };
};
